import { render } from "./EventLocation.vue?vue&type=template&id=6349853a"
import script from "./EventLocation.vue?vue&type=script&lang=js"
export * from "./EventLocation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/morris.lin/Self/project/vue-rick-and-morty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__